import type { RouteLocationNormalized } from "vue-router"

/**
 * Routes fiche bâtiment (sidebar building ou URL `/building/:id/...`).
 */
export function isBuildingSidebarRoute(
    route: RouteLocationNormalized
): boolean {
    if (route.meta.sidebar === "building") return true
    return /^\/building\/[^/]+/.test(route.path)
}

/**
 * Routes fiche source (sidebar source ou URL `/source/:id/...`), hors liste `/source`.
 */
export function isSourceSidebarRoute(route: RouteLocationNormalized): boolean {
    if (route.meta.sidebar === "source") return true
    return /^\/source\/[^/]+/.test(route.path)
}

/** Textes toast affichés après redirection pour accès refusé (FR). */
export const restrictedAccessRedirectToast = {
    building: {
        summary: "Accès refusé",
        detail: "Vous n'avez pas accès à ce bâtiment.",
    },
    source: {
        summary: "Accès refusé",
        detail: "Vous n'avez pas accès à cette source (objet connecté).",
    },
    /** Après redirection : lien CompanySource `views` révoqué (GET source métier). */
    sourceViewsLinkRevoked: {
        summary: "Source plus accessible",
        detail: "Cette source a été retirée : vous n'y avez plus accès.",
    },
} as const
